import { Component, OnInit, Input, NgModule } from '@angular/core';
import { FormControl,FormBuilder, FormGroup, NgModel, Validators } from '@angular/forms';
import { LoadingDialogComponent} from '../../../../../app/Core/components/loading-dialog/loading-dialog.component';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { AuthService } from 'src/app/Core/services/auth.service';
import { ActivatedRoute } from '@angular/router';
// import { OtaUploadComponent } from '../ota-upload/ota-upload.component';
import { UserService } from 'src/app/Core/services/user.service';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-ota-module',
  templateUrl: './ota-module.component.html',
  styleUrls: ['./ota-module.component.css']
})


export class OtaModuleComponent implements OnInit {
  fileUploadForm: FormGroup = new FormGroup({});
  selectedFile: File | null = null;
  fileUploaded = false;
  isModalOpen = false;

  constructor(
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private userService: UserService,
    private authService: AuthService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.fileUploadForm = this.formBuilder.group({
      selectedModel: ['all', Validators.required],
      versionNo: ['', Validators.required],
      extractedName: ['', Validators.required],
      Description: [''],
    });
  }

  onFileSubmit() {
    if (this.selectedFile) {
      this.fileUploaded = true;
      const formData = new FormData();
      formData.append('model', JSON.stringify(this.fileUploadForm.value));
      formData.append('file', this.selectedFile);
      const dialogRef = this.dialog.open(LoadingDialogComponent, {
        disableClose: true,
        width: '500px',
        height: '200px'
      });
      this.http.post(`${environment.host}/createotajob`, formData).subscribe(
        (response) => {
          dialogRef.componentInstance.dailogContent = `OTA JOB Creation Succesfull:  ${this.fileUploadForm.get('extractedName')?.value}`;
          dialogRef.componentInstance.showFileFailedMessage = true;
          clearTimeout(timeout);
          // Extract job name and firmware version
          const fileName = this.selectedFile!.name!;
          const regex = /(.+)-v(\d+\.\d+-.*)/;
          const match = fileName.match(regex);
          if (match) {
            const jobName = match[1];
            const firmwareVersion = `v${match[2]}`;
            console.log('Job Name:', jobName);
            console.log('Firmware Version:', firmwareVersion);
          }
        },
        (error) => {
          console.error('File upload failed:', error);
          this.fileUploaded = false;
          dialogRef.componentInstance.dailogContent = 'Creation of OTA job Failed';
          dialogRef.componentInstance.showFileFailedMessage = true;
          clearTimeout(timeout);
        }  );
        const timeout = setTimeout(() => {
          dialogRef.componentInstance.dailogContent = 'Creation of OTA job Failed';
        }, 10000);
      }

      
    }
    onFileSelection(event: any) {
      this.selectedFile = event.target.files[0];
    }

}
export class DialogContentExampleDialog {
}
